var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneSolid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.258,
    height: 9.73,
    viewBox: "0 0 19.258 9.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Page_1_Copy_2",
    "data-name": "Page 1 Copy 2",
    d: "M19.025,4.212,17.709,3.6a.4.4,0,0,0-.382.022L14.745,5.209a.4.4,0,0,1-.394.016L6.357,1.17l-.028-.016A8.258,8.258,0,0,0,1.7.021S-.187-.18.015,1.166C.21,2.46,4.388,4.249,5.666,4.623a.394.394,0,0,1,.222.17L8.5,8.921a.4.4,0,0,0,.193.16l1.581.621a.4.4,0,0,0,.551-.351l.132-2.186a.4.4,0,0,1,.547-.352,21.079,21.079,0,0,0,6.687,1.472c.29,0-.324-.73-.692-1.14A.4.4,0,0,1,17.5,6.6l1.644-1.743a.4.4,0,0,0-.123-.643Z",
    fill: "#05ce78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneSolid);
export default __webpack_public_path__ + "static/media/plane-solid.dfd360f34fec214d8c1c22daa7aeab05.svg";
export { ForwardRef as ReactComponent };